import { render, staticRenderFns } from "./arguments.vue?vue&type=template&id=9e7468b8"
import script from "./arguments.vue?vue&type=script&lang=js"
export * from "./arguments.vue?vue&type=script&lang=js"
import style0 from "../index.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports